import { Component, Input, OnInit } from '@angular/core';
import { HttpserviceService } from '../../../../services/httpservice.service';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { ImpresionetiquetasService } from '../../../../services/impresionetiquetas.service';
import { DialogComponent } from '../../../modal-overlays/dialog/dialog.component';
import { AuthService } from '../../../../auth.service';

@Component({
  selector: 'ngx-infopalet',
  templateUrl: './infopalet.component.html',
  styleUrls: ['./infopalet.component.scss']
})
export class InfopaletComponent implements OnInit  {
  @Input() data: string;
  public id: string = '';
  public palets: any[] = [];
  public picking: any[] = [];
  public movimientos: any[] = [];
  public palet: any = null;
  public productos: any[] = [];
  public tiposCaja: any[] = [];
  public editPaletDraft: any = null;
  private stockCajasOriginal: number | null = null;
  public isEditingPaletData: boolean = false;
  public anotaciones: string = '';
  public isEditingAnotaciones: boolean = false;
public isListening: boolean = false;
public interimText: string = '';
public errorMessage: string = '';
private recognition: any;
private shouldRestart: boolean = false;

getEstadoTexto(): string {
  if (!this.palet) {
    return '';
  }
  const vendidoRaw = (this.palet as any).vendido;
  const vendido = vendidoRaw === true || vendidoRaw === 't' || vendidoRaw === '1' || vendidoRaw === 1;
  const estado = Number(this.palet.estado);

  if (vendido) {
    return '5 Retirado venta';
  }

  switch (estado) {
    case 1:
      return '1 Pendiente entrada';
    case 2:
      return '2 Almacenado';
    case 3:
      return '3 Pendiente retirada venta';
    case 4:
      return '4 Merma';
    case 5:
      return '5 Retirado venta';

    default:
      return 'Desconocido';
  }
}

getHuecoTexto(palet: any): string {
  if (!palet) {
    return '';
  }

  const hueco = Number(palet.hueco);
  const huecosTotales = Number(palet.huecos_totales);

  if (!hueco || !huecosTotales) {
    return 'No aplica';
  }

  return `${hueco} de ${huecosTotales}`;
}


get transformacionInfo(): any {
  return this.palet?.transformacion || null;
}

getEstadoPartidaTransformacionTexto(estado: any): string {
  const value = String(estado || '').toUpperCase();
  if (value === 'EN_CURSO') {
    return 'En curso';
  }
  if (value === 'BLOQUEADO') {
    return 'Pausada';
  }
  if (value === 'FINALIZADO') {
    return 'Finalizada';
  }
  if (value === 'CANCELADO') {
    return 'Cancelada';
  }
  return value ? 'Pendiente' : '-';
}


openTransformacionPartida(): void {
  const idpartida = Number(this.transformacionInfo?.idpartida_transformacion || 0);
  if (!idpartida) {
    return;
  }
  const idlinea = Number(this.transformacionInfo?.idlinea_pedido_transformacion || 0);
  const queryParts: string[] = [`idpartida=${idpartida}`, 'origen_flujo=palet_transformacion'];
  if (idlinea > 0) {
    queryParts.push(`idlinea=${idlinea}`);
  }
  const query = `?${queryParts.join('&')}`;
  window.open(`/pages/camaras/partidas-transformacion${query}`, '_blank');
}

openTransformacionPedido(): void {
  const idpedido = Number(this.transformacionInfo?.idpedido_transformacion || 0);
  if (!idpedido) {
    return;
  }
  const idpartida = Number(this.transformacionInfo?.idpartida_transformacion || 0);
  const queryParts: string[] = [`idpedido=${idpedido}`];
  if (idpartida > 0) {
    queryParts.push(`idpartida=${idpartida}`);
  }
  const idlinea = Number(this.transformacionInfo?.idlinea_pedido_transformacion || 0);
  if (idlinea > 0) {
    queryParts.push(`idlinea=${idlinea}`);
  }
  queryParts.push('origen_flujo=palet_transformacion');
  window.open(`/pages/camaras/pedidos-transformacion?${queryParts.join('&')}`, '_blank');
}

openRelatedPalet(idpalet: any, loteAliquo?: string): void {
  const identificador = String(loteAliquo || idpalet || '').trim();
  if (!identificador) {
    return;
  }
  this.dialogService.open(InfopaletComponent, {
    context: {
      data: identificador,
    },
  });
}

displayedColumns: string[] = ['ubicacion', 'idpalet', 'producto', 'calibre', 'proveedor', 'n_cajas', 'peso_bruto', 'peso_neto', 'peso_tara', 'estado', 'fechaentrada'];

get canEditPaletData(): boolean {
  return this.authService.isManager();
}

readonly estadoOptions = [
  { value: 1, label: '1 Pendiente entrada' },
  { value: 2, label: '2 Almacenado' },
  { value: 3, label: '3 Pendiente retirada venta' },
  { value: 4, label: '4 Merma' },
  { value: 5, label: '5 Retirado venta' },
];


constructor(
  private http: HttpserviceService,
  private impresion: ImpresionetiquetasService,
  protected ref: NbDialogRef<DialogComponent>,
  private authService: AuthService,
  private dialogService: NbDialogService,
) {
  this.initSpeechRecognition();
}

ngOnInit(): void {
  this.id = this.data;

  if (this.canEditPaletData) {
    this.loadPaletEditCatalogs();
  }

  if (!this.id && this.id !== '0') {
    console.error('InfopaletComponent: id de palet no proporcionado');
    return;
  }

  this.http.getInfoPalet(this.id).subscribe((data: any) => {
    if (data.code == 1) {
      const palets = Array.isArray(data?.data?.palets) && data.data.palets.length
        ? data.data.palets
        : (data?.data?.palet ? [data.data.palet] : []);

      this.palets = palets.map((palet: any) => ({
        ...palet,
        ubicacion: this.getUbicacionActualTexto(palet),
      }));

      if (this.palets.length === 1) {
        this.seleccionarPalet(this.palets[0]);
      } else {
        this.palet = null;
        this.picking = [];
        this.movimientos = [];
      }
    } else {
      console.error('Error al obtener info palet:', data.mensaje);
    }
  });
}

editAnotaciones() {
  this.isEditingAnotaciones = true;
}

cancelAnotaciones() {
  this.anotaciones = this.palet.anotaciones || '';
  this.isEditingAnotaciones = false;
}

saveAnotaciones() {
  this.http.saveAnotacionPalet(this.palet.idpalet, this.anotaciones).subscribe((response: any) => {
    if (response.code === 1) {
      this.palet.anotaciones = this.anotaciones;
      this.isEditingAnotaciones = false;
      console.log('Anotación guardada correctamente');
    } else {
      console.error('Error al guardar anotación:', response.mensaje);
    }
  });
}

dismiss() {
  this.ref.close();
}

seleccionarPalet(palet: any): void {
  if (!palet) {
    return;
  }

  if (this.isSelectedPalet(palet)) {
    this.palet = null;
    this.picking = [];
    this.movimientos = [];
    this.anotaciones = '';
    this.isEditingAnotaciones = false;
    this.cancelEditPaletData();
    return;
  }

  this.applySelectedPalet(palet);
}

private applySelectedPalet(palet: any): void {
  this.palet = palet;
  this.picking = Array.isArray(palet.historico_salidas) ? palet.historico_salidas : [];
  this.anotaciones = palet.anotaciones || '';
  this.isEditingAnotaciones = false;
  this.cancelEditPaletData();
  this.movimientos = [];
  this.cargarMovimientosPalet(palet.idpalet);
}

private cargarMovimientosPalet(idpalet: number): void {
  this.http.getHistoricoMovimientosPalet(idpalet).subscribe((data: any) => {
    if (data.code == 1) {
      this.movimientos = (data.data || [])
        .map((mov: any) => ({
          ...mov,
          ubicacion_inicial: this.normalizeMovementLocation(mov.idposicion_inicial, mov.ubicacion_inicial),
          ubicacion_final: this.normalizeMovementLocation(mov.idposicion_final, mov.ubicacion_final),
        }))
        .sort((a: any, b: any) => {
          const fechaA = new Date(a?.fecha || 0).getTime();
          const fechaB = new Date(b?.fecha || 0).getTime();
          return fechaB - fechaA;
        });
    } else {
      this.movimientos = [];
      console.error('Error al obtener movimientos del palet:', data.mensaje);
    }
  });
}

onPrintEtiquetaInterna(palet: any): void {
  const idpalet = Number(palet?.idpalet || this.palet?.idpalet || 0);
  if (!idpalet) {
    return;
  }

  if (confirm('¿Seguro que quiere imprimir la etiqueta interna del palet?')) {
    const idubicacion = Number((this.http as any).idubicacion || 1);
    const idcamara = Number((this.http as any).idcamara || 0);
    this.impresion.imprimepalet(idubicacion, idpalet, idcamara);
  }
}

startEditPaletData(): void {
  if (!this.canEditPaletData || !this.palet) {
    return;
  }

  const producto = this.productos.find((item: any) => Number(item?.idproducto || 0) === Number(this.palet?.idproducto || 0)) || null;
  const tipoCaja = this.tiposCaja.find((item: any) =>
    String(item?.codigo || '') === String(this.palet?.tipo_caja_codigo || this.palet?.codigo_caja || '')
  ) || null;

  this.stockCajasOriginal = this.toNullableNumber(this.palet?.stock_cajas);
  this.editPaletDraft = {
    idpalet: Number(this.palet?.idpalet || 0),
    identrada: Number(this.palet?.identrada || 0),
    idproducto: (producto?.idproducto ?? Number(this.palet?.idproducto || 0)) || null,
    producto: producto,
    codigo_caja: tipoCaja,
    estado: Number(this.palet?.estado || 1),
    n_cajas_entrada: Number(this.palet?.n_cajas_entrada ?? this.palet?.n_cajas ?? 0) || 0,
    stock_cajas: this.stockCajasOriginal,
    peso_bruto: this.palet?.peso_bruto ?? null,
    peso_neto: this.palet?.peso_neto ?? null,
    peso_tara: this.palet?.peso_tara ?? null,
    tara_caja: this.palet?.tara_caja ?? null,
    categoria: this.palet?.categoria || '',
    calibre: this.palet?.calibre || '',
  };
  this.isEditingPaletData = true;
}

cancelEditPaletData(): void {
  this.isEditingPaletData = false;
  this.editPaletDraft = null;
  this.stockCajasOriginal = null;
}

saveEditPaletData(): void {
  if (!this.canEditPaletData || !this.palet || !this.editPaletDraft) {
    return;
  }

  const producto = this.editPaletDraft.producto || null;
  const tipoCaja = this.editPaletDraft.codigo_caja || null;
  const stockCajasNuevo = this.toNullableNumber(this.editPaletDraft.stock_cajas);
  const stockCajasModificado = stockCajasNuevo !== this.stockCajasOriginal;

  if (stockCajasModificado && (stockCajasNuevo === null || stockCajasNuevo < 0)) {
    alert('Indique un stock de cajas válido.');
    return;
  }

  const payload: any = {
    idpalet: Number(this.palet.idpalet || 0),
    identrada: Number(this.palet.identrada || 0),
    idproducto: (producto?.idproducto ?? this.editPaletDraft.idproducto ?? null),
    producto: producto?.nombre || this.palet?.producto || '',
    codigo_caja: tipoCaja?.codigo || this.palet?.codigo_caja || '',
    estado: Number(this.editPaletDraft.estado || this.palet?.estado || 1),
    n_cajas: Number(this.editPaletDraft.n_cajas_entrada ?? this.palet?.n_cajas_entrada ?? this.palet?.n_cajas ?? 0),
    n_cajas_entrada: Number(this.editPaletDraft.n_cajas_entrada ?? this.palet?.n_cajas_entrada ?? this.palet?.n_cajas ?? 0),
    peso_bruto: this.editPaletDraft.peso_bruto ?? this.palet?.peso_bruto ?? null,
    peso_neto: this.editPaletDraft.peso_neto ?? this.palet?.peso_neto ?? null,
    peso_tara: this.editPaletDraft.peso_tara ?? this.palet?.peso_tara ?? null,
    tara_caja: this.editPaletDraft.tara_caja ?? this.palet?.tara_caja ?? null,
    categoria: this.editPaletDraft.categoria ?? this.palet?.categoria ?? '',
    calibre: this.editPaletDraft.calibre ?? this.palet?.calibre ?? '',
  };

  if (stockCajasModificado) {
    payload.actualizar_stock_cajas = true;
    payload.stock_cajas = stockCajasNuevo;
    payload.stock_cajas_esperado = this.stockCajasOriginal;
  }

  this.http.modifyPalet(payload, 1).subscribe((response: any) => {
    if (response?.code === 1) {
      this.reloadCurrentPalet();
      this.cancelEditPaletData();
      return;
    }
    alert(response?.mensaje || 'No se pudo actualizar el palet');
  }, (error: any) => {
    alert(error?.error?.mensaje || 'No se pudo actualizar el palet');
  });
}

private reloadCurrentPalet(): void {
  if (!this.id && this.id !== '0') {
    return;
  }
  const selectedId = Number(this.palet?.idpalet || 0);
  this.http.getInfoPalet(this.id).subscribe((data: any) => {
    if (data?.code !== 1) {
      return;
    }
    const palets = Array.isArray(data?.data?.palets) && data.data.palets.length
      ? data.data.palets
      : (data?.data?.palet ? [data.data.palet] : []);
    this.palets = palets.map((palet: any) => ({ ...palet, ubicacion: this.getUbicacionActualTexto(palet) }));
    const refreshed = this.palets.find((item: any) => Number(item?.idpalet || 0) === selectedId) || this.palets[0] || null;
    if (refreshed) {
      this.applySelectedPalet(refreshed);
    }
  });
}

private loadPaletEditCatalogs(): void {
  this.http.getProductos(1).subscribe((response: any) => {
    this.productos = Array.isArray(response?.data) ? response.data : [];
  });
  this.http.getTiposCaja(1).subscribe((response: any) => {
    this.tiposCaja = Array.isArray(response?.data) ? response.data : [];
  });
}

private toNullableNumber(value: any): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsed = Number(value);
  if (isNaN(parsed)) {
    return null;
  }

  return parsed;
}

isSelectedPalet(palet: any): boolean {
  return !!this.palet && !!palet && Number(this.palet.idpalet) === Number(palet.idpalet);
}

private initSpeechRecognition(): void {
  const { webkitSpeechRecognition }: any = window;
  if (webkitSpeechRecognition) {
    this.recognition = new webkitSpeechRecognition();
    this.recognition.lang = 'es-ES';
    this.recognition.interimResults = true;
    this.recognition.maxAlternatives = 1;

    this.recognition.onresult = (event: any) => {
      const transcript = event.results[0][0].transcript;
      if (event.results[0].isFinal) {
        this.anotaciones += transcript + ' ';
        this.interimText = '';
      } else {
        this.interimText = transcript;
      }
    };

    this.recognition.onerror = (event: any) => {
      this.errorMessage = 'Error de reconocimiento: ' + event.error;
      this.isListening = false;
    };

    this.recognition.onend = () => {
      if (this.shouldRestart) {
        this.recognition.start();
      } else {
        this.isListening = false;
      }
    };
  }
}

startListening(): void {
  if (this.recognition) {
    this.errorMessage = '';
    this.isListening = true;
    this.shouldRestart = true;
    this.recognition.start();
  } else {
    this.errorMessage = 'Reconocimiento de voz no disponible en este navegador';
  }
}

stopListening(): void {
  if (this.recognition) {
    this.shouldRestart = false;
    this.recognition.stop();
    if (this.interimText) {
      this.anotaciones += this.interimText + ' ';
      this.interimText = '';
    }
  }
  this.isListening = false;
}

getUbicacionActualTexto(palet: any): string {
  if (!palet) {
    return '';
  }

  if (palet.idposicion === -1) {
    return 'Suelo';
  }

  if (palet.idposicion === null || palet.idposicion === undefined) {
    return 'Fuera de cámara';
  }

  const ubicacion = typeof palet.ubicacion === 'string' ? palet.ubicacion.trim() : '';
  return ubicacion || 'Sin ubicación';
}

private normalizeMovementLocation(idposicion: number | null | undefined, ubicacion: string | null | undefined): string {
  if (idposicion === -1) {
    return 'Suelo';
  }

  if (idposicion === null || idposicion === undefined) {
    return 'Fuera de cámara';
  }

  const ubicacionLimpia = typeof ubicacion === 'string' ? ubicacion.trim() : '';
  return ubicacionLimpia || 'Sin ubicación';
}

}
